import { Component, ModuleWithProviders, NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { ForgotPasswordComponent } from './Components/forgot-password/forgot-password.component';
import { LoginComponent } from './Components/login/login.component';
import { VerifyOtpComponent } from './Components/verify-otp/verify-otp.component';
import { HomePageComponent } from './modules/layoutShopModule/shop-components/home-page/home-page.component';

const routes: Routes = [
  {
    path: '',
    redirectTo: '/home-page',
    pathMatch: 'full'
  },
  {
    path: 'web',
    loadChildren: () =>
      import('../app/modules/layoutModule/layout-container/layout-container.module').then((m) => m.LayoutContainerModule),
  },
  {
    path: 'web',
    loadChildren: () =>
      import('../app/modules/layoutShopModule/shop-layout/shop-layout-container.module').then((m) => m.ShopLayoutContainerModule)
  },
  { path: 'home-page', component: HomePageComponent },
  { path: 'login', component: LoginComponent },
  { path: 'forgotpassword', component: ForgotPasswordComponent },
  { path: 'resetPassword/:token', component: VerifyOtpComponent },

];

@NgModule({
  imports: [RouterModule.forRoot(routes, { useHash: true })],
  exports: [RouterModule]
})
export class AppRoutingModule { }

